// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.Ozmqb{cursor:initial}.Ozmqb:hover,.Ozmqb:focus{color:inherit}@media(min-width: 992px){.ORoLo th{padding:8px 4px}}@media(min-width: 768px)and (max-width: 991px){.ORoLo th{padding:4px}}@media only screen and (max-width: 767px){.ORoLo{min-width:0}}@media(min-width: 992px){.ORoLo:last-child{padding:8px 4px}}@media(min-width: 768px)and (max-width: 991px){.ORoLo:last-child{padding:4px !important}}.vgHX5{height:56px}.ORoLo:hover .mK1WM,.mK1WM{visibility:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": "Ozmqb",
	"generalStylesCell": "ORoLo",
	"tableHeadRow": "vgHX5",
	"hiddenSortIcon": "mK1WM"
};
module.exports = ___CSS_LOADER_EXPORT___;
